export function getBrokenNumber(number) {
    if (isNaN(number)) {
        return;
    }

    const intNum = Math.trunc(number);

    return {
        integerPart: intNum,
        fractionalPart: number - intNum,
    };
}
